export const LABEL_COLOR = [
  {
    label: '深红色',
    value: 'dark-red',
    background: '#ff6644',
    color: '#fff',
  },
  {
    label: '浅红色',
    value: 'light-red',
    background: '#FFEEEB',
    color: '#FF6644',
  },
  {
    label: '橙色',
    value: 'orange',
    background: '#FFE6B5',
    color: '#D25F00',
  },
  {
    label: '绿色',
    value: 'green',
    background: '#E8FFEA',
    color: '#008026',
  },
  {
    label: '深蓝色',
    value: 'dark-blue',
    background: '#E8F2FF',
    color: '#1033A3',
  },
  {
    label: '青色',
    value: 'cyan',
    background: '#E8FFFB',
    color: '#07828B',
  },
  {
    label: '粉色',
    value: 'pink',
    background: '#FFE8FB',
    color: '#8A0993',
  },
  {
    label: '紫色',
    value: 'purple',
    background: '#F5E8FF',
    color: '#3C108F',
  },
  {
    label: '金色',
    value: 'gold',
    background: '#FFFCE8',
    color: '#A26D0A',
  },
];

export const GRADUATION_YEARS = [
  { label: '2022及以前', value: '2022及以前' },
  { label: '2023', value: '2023' },
  { label: '2024', value: '2024' },
  { label: '2025', value: '2025' },
  { label: '2026', value: '2026' },
  { label: '2027及以后', value: '2027及以后' },
];

export const EDUCATION_REQUIREMENTS = [
  { label: '不限', value: '不限' },
  { label: '大专', value: '大专' },
  { label: '本科', value: '本科' },
  { label: '硕士', value: '硕士' },
  { label: '博士', value: '博士' },
  { label: 'MBA', value: 'MBA' },
];

export const COMPANY_NATURES = [
  { label: '央企国企', value: '央企国企' },
  { label: '外企', value: '外企' },
  { label: '合资', value: '合资' },
  { label: '民企', value: '民企' },
  { label: '事业单位', value: '事业单位' },
  { label: '政府机关', value: '政府机关' },
  { label: '社会组织', value: '社会组织' },
  { label: '其他', value: '其他' },
];

export const RECRUITMENT_BATCHES = [
  { label: '秋招提前批', value: '秋招提前批' },
  { label: '秋招', value: '秋招' },
  { label: '秋招补录', value: '秋招补录' },
  { label: '春招提前批', value: '春招提前批' },
  { label: '春招', value: '春招' },
  { label: '春招补录', value: '春招补录' },
  { label: '暑期实习', value: '暑期实习' },
  { label: '寒假实习', value: '寒假实习' },
];

export const TAB_LIST = [
  {
    name: '校招信息汇总',
  },
  {
    name: '校招日历',
  },
];

export const APPLICATION_STATUSES = [
  {
    label: '待投递',
    value: '待投递',
    background: '#E8F2FF',
    color: '#1033A3',
  },
  {
    label: '已投递',
    value: '已投递',
    background: '#E8F2FF',
    color: '#1033A3',
  },
  {
    label: '待笔试',
    value: '待笔试',
    background: '#F5E8FF',
    color: '#3C108F',
  },
  {
    label: '已笔试',
    value: '已笔试',
    background: '#F5E8FF',
    color: '#3C108F',
  },
  {
    label: '一面',
    value: '一面',
    background: '#FFF7E8',
    color: '#D25F00',
  },
  {
    label: '二面',
    value: '二面',
    background: '#FFF7E8',
    color: '#D25F00',
  },
  {
    label: '三面',
    value: '三面',
    background: '#FFF7E8',
    color: '#D25F00',
  },
  {
    label: '有 offer',
    value: '有 offer',
    background: '#E8FFEA',
    color: '#008026',
  },
  {
    label: '未通过',
    value: '未通过',
    background: '#FFECE8',
    color: '#CB272D',
  },
];

